import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Calendar, ArrowUpRight } from "lucide-react";

function scrollToContact() {
  const el = document.getElementById("contact");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function StickyCta() {
  const [show, setShow] = useState(false);
  const [hideAtContact, setHideAtContact] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      // Show once user has scrolled past first viewport
      setShow(window.scrollY > window.innerHeight * 0.6);

      // Hide when contact section enters viewport (avoid covering form submit)
      const contact = document.getElementById("contact");
      if (contact) {
        const rect = contact.getBoundingClientRect();
        setHideAtContact(rect.top < window.innerHeight * 0.8);
      }
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const visible = show && !hideAtContact;

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          key="sticky-cta"
          data-testid="sticky-cta"
          type="button"
          onClick={scrollToContact}
          initial={{ opacity: 0, y: 30, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 30, scale: 0.95 }}
          transition={{ duration: 0.35, ease: [0.2, 0.6, 0.2, 1] }}
          className="group fixed z-40 bottom-6 right-6 md:bottom-8 md:right-8 inline-flex items-center gap-2.5 md:gap-3 pl-4 md:pl-5 pr-3.5 md:pr-4 py-3 md:py-3.5 rounded-full bg-[#1A1A1A] text-[#FDFCFB] text-[13px] md:text-sm font-medium tracking-tight shadow-[0_20px_40px_-12px_rgba(0,0,0,0.55)] hover:shadow-[0_26px_50px_-12px_rgba(0,0,0,0.65)] hover:-translate-y-0.5 transition-all duration-300"
          aria-label="Book a free consultation"
        >
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#7EE787] opacity-70" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-[#7EE787]" />
          </span>
          <Calendar className="w-4 h-4 md:hidden" strokeWidth={1.8} />
          <span className="hidden md:inline">Book a Free Consultation</span>
          <span className="md:hidden">Book Free Call</span>
          <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
